<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';

	import { format } from 'src/services/i18n';

	import { MenuItemList } from '@Shelly/shelly-design-system';
	import { getMoreMenuItemNavigateHref, type MenuItemDef } from 'src/helpers/main_menu';
	import type { ProfileMenuEvents } from './DropdownItem.types';
	import ProfileMenuContent from './ProfileMenuContent.svelte';

	export let moreMenuItems: MenuItemDef[] = [];
	export let showHomeList = false;
	export let hideMenuItemsOnHomeList = true;

	interface Events extends ProfileMenuEvents {
		closeMenu: void;
		logout: void;
		addProfile: void;
		logoutAllProfiles: void;
	}

	const dispatch = createEventDispatcher<Events>();

	$: shouldShowMenuItems = hideMenuItemsOnHomeList ? !showHomeList : true;
</script>

<div class="p-m">
	<ProfileMenuContent
		bind:showHomeList
		on:profileClick
		on:addProfile
		on:logoutAllProfiles
		on:homeClick
		on:editProfile
		on:logoutProfile
		on:manageHome
	/>
</div>

{#if shouldShowMenuItems}
	<div class="pt-xs pb-s">
		{#each moreMenuItems as item}
			<MenuItemList
				isGroupItem
				class={'pt-s pb-s pl-l-plus'}
				title={$format(item.label, {
					default: item.labelDefault,
				})}
				icon={item.icon}
				on:click={() => {
					dispatch('closeMenu');
					replace(getMoreMenuItemNavigateHref(item));
				}}
			/>
		{/each}
	</div>
{/if}

{#if shouldShowMenuItems}
	<hr class="" />
	<MenuItemList
		class={'pl-l-plus pr-l-plus '}
		title={$format('logout', {
			default: 'Log out',
		})}
		icon={'fa-regular fa-circle-x'}
		on:click={() => dispatch('logout')}
	/>
{/if}
